"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomPagination_1 = require("../../../Common/CustomPagination");
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const fa_1 = require("react-icons/fa");
const user_api_1 = require("../../../../utils/api/user/user.api");
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const AddOrUpdateAdminModal_1 = __importDefault(require("../modals/AddOrUpdateAdminModal"));
const UseCrudAdmin_1 = require("../requestForm/UseCrudAdmin");
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const md_1 = require("react-icons/md");
const react_switch_1 = __importDefault(require("react-switch"));
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const theme_1 = require("../../../../utils/theme");
const DeleteButton = ({ id }) => {
    const onDelete = (0, UseCrudAdmin_1.useDeleteUser)(id);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-delete", "data-tooltip-content": "Supprimer", style: { color: "#E53E3E" }, onClick: () => onDelete() },
            react_1.default.createElement(fa_1.FaTrash, null))));
};
const AdministrateurTable = ({ search }) => {
    const [page, setPage] = react_1.default.useState(1);
    const [perPage, setPerPage] = react_1.default.useState(10);
    const [item, setItem] = react_1.default.useState(null);
    const [show, setShow] = react_1.default.useState(false);
    const handleShow = (item) => {
        setItem(item);
        setShow(true);
    };
    const handleClose = () => setShow(false);
    const { data, isLoading } = (0, user_api_1.useGetStaffListQuery)({
        page: page,
        limit: perPage,
        word: search
    });
    const [toggleUserActive] = (0, user_api_1.useToogleEnableOrDisableUserMutation)();
    const toggleActive = (item) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const action = (item === null || item === void 0 ? void 0 : item.is_active) === 1 ? "désactiver" : "activer";
        const result = yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir ${action} cet administrateur ?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                var _a;
                try {
                    return yield toggleUserActive(item === null || item === void 0 ? void 0 : item.user_id);
                }
                catch (err) {
                    sweetalert2_1.default.showValidationMessage(((_a = err === null || err === void 0 ? void 0 : err.data) === null || _a === void 0 ? void 0 : _a.message) ||
                        `Une erreur de statut ${(err === null || err === void 0 ? void 0 : err.status) || "inconnue"} est survenue`);
                    throw err;
                }
            }),
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        });
        if (result === null || result === void 0 ? void 0 : result.isConfirmed) {
            const responseData = (_a = result === null || result === void 0 ? void 0 : result.value) === null || _a === void 0 ? void 0 : _a.data;
            if ((responseData === null || responseData === void 0 ? void 0 : responseData.success) && (responseData === null || responseData === void 0 ? void 0 : responseData.data)) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: (responseData === null || responseData === void 0 ? void 0 : responseData.message) || `Administrateur ${responseData.data.is_active === 1
                        ? "activé"
                        : "désactivé"} avec succès !`,
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
            else if (responseData && !(responseData === null || responseData === void 0 ? void 0 : responseData.success)) {
                sweetalert2_1.default.fire({
                    icon: "error",
                    title: (responseData === null || responseData === void 0 ? void 0 : responseData.message) || "Une erreur est survenue",
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 3000,
                });
            }
        }
    });
    const activeFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "d-flex justify-content-start align-items-center" },
            react_1.default.createElement(react_switch_1.default, { checked: cell === 1, onChange: () => toggleActive(row), handleDiameter: 12, height: 18, width: 34, offHandleColor: "#4B4B4B", onHandleColor: "#0288D1", offColor: "#F9FAFB", onColor: "#F9FAFB", uncheckedIcon: false, checkedIcon: false, boxShadow: "none", activeBoxShadow: "none", className: "custom-switch", id: "custom-switch-id" })));
    };
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "table-actions-btn-container-commandes d-flex justify-content-start gap-3" },
            react_1.default.createElement("div", { className: "container-btn-action-icon-modal d-flex justify-content-center" },
                react_1.default.createElement("button", { className: "btn btn-action-modal-icon with-tooltip", "data-tooltip-content": "Voir", onClick: () => handleShow(row), style: { color: "#2B6CB0" } },
                    react_1.default.createElement(md_1.MdEdit, null))),
            react_1.default.createElement(DeleteButton, { id: row === null || row === void 0 ? void 0 : row.user_id })));
    };
    const columns = [
        {
            dataField: "fullname",
            text: "Nom de l’utilisateur",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "email",
            text: "Adresse mail",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "status",
            text: "Type d'utilisateur",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
            formatter: (cell) => {
                return (react_1.default.createElement("span", { className: `badge ${(cell === null || cell === void 0 ? void 0 : cell.includes('admin')) ? "bg-primary" : cell === 'collaborator' ? "bg-secondary" : cell === 'management' ? 'bg-info' : cell === 'staff' ? 'bg-dark' : 'bg-danger'}` }, (cell === null || cell === void 0 ? void 0 : cell.includes('admin')) ? "Admin" : cell === 'collaborator' ? "Opérateur PC" : (cell === 'management') ? 'Management' : (cell === 'staff') && 'Staff'));
            }
        },
        {
            dataField: "is_active",
            text: "Active",
            formatter: activeFormatter,
            headerStyle: () => {
                return {
                    width: "100px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "col-lg-12" },
            react_1.default.createElement("div", { className: "admin-table" },
                !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
                !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: (data === null || data === void 0 ? void 0 : data.data) || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })) }),
                    react_1.default.createElement("div", { className: "custom-pagination-container" },
                        react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: (data === null || data === void 0 ? void 0 : data.count) || 0, page: page, onChange: (page, perPage) => {
                                setPerPage(perPage);
                                setPage(page);
                            }, perPage: perPage }))))),
            react_1.default.createElement(AddOrUpdateAdminModal_1.default, { show: show, handleClose: handleClose, item: item }))));
};
exports.default = AdministrateurTable;
const data = [
    {
        id: 1,
        email: "ibou@gmail.com",
        nom: "Ibrahima Dansokho",
        telephone: "77 000 00 00",
        adresse: "Dakar, Sénégal",
    },
    {
        id: 2,
        email: "ibou@gmail.com",
        nom: "Ibrahima Dansokho",
        telephone: "77 000 00 00",
        sos: "7",
        adresse: "Dakar, Sénégal",
    },
    {
        id: 3,
        email: "ibou@gmail.com",
        nom: "Ibrahima Dansokho",
        telephone: "77 000 00 00",
        adresse: "Dakar, Sénégal",
    },
    {
        id: 4,
        email: "ibou@gmail.com",
        nom: "Ibrahima Dansokho",
        telephone: "77 000 00 00",
        adresse: "Dakar, Sénégal",
    },
    {
        id: 5,
        email: "ibou@gmail.com",
        nom: "Ibrahima Dansokho",
        telephone: "77 000 00 00",
        adresse: "Dakar, Sénégal",
    },
    {
        id: 6,
        email: "ibou@gmail.com",
        nom: "Ibrahima Dansokho",
        telephone: "77 000 00 00",
        adresse: "Dakar, Sénégal",
    },
    {
        id: 7,
        email: "ibou@gmail.com",
        nom: "Ibrahima Dansokho",
        telephone: "77 000 00 00",
        adresse: "Dakar, Sénégal",
    },
];
